import { FC, useCallback, useRef } from 'react';

import ArrowDownIcon from '@z-components/static/images/icon-arrow-drop-down.svg';
import ArrowUpIcon from '@z-components/static/images/icon-arrow-drop-up.svg';

import styles from './Tab.module.scss';

interface Props {
  direction?: 'asc' | 'desc';
  isDisabled?: boolean;
  label?: string;
  onClick?: (offsetLeft?: number) => void;
  selected?: boolean;
  style?: 'fill' | 'hollow';
  testId?: string;
}

const Tab: FC<Props> = ({
  direction,
  isDisabled = false,
  label = '',
  onClick = () => null,
  selected = false,
  style = 'fill',
  testId,
}) => {
  const tabRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(() => {
    onClick(tabRef.current?.offsetLeft);
  }, [onClick]);

  const styleTabSelected =
    style === 'hollow'
      ? [styles['z-tab-hollow-selected'], styles['z-tab-hollow-unselected']]
      : [styles['z-tab-selected'], styles['z-tab-unselected']];

  return (
    <button
      ref={tabRef}
      data-test-id={testId}
      className={selected ? styleTabSelected[0] : styleTabSelected[1]}
      disabled={isDisabled}
      onClick={handleClick}
      type="button"
    >
      <span className={styles['z-tab-label']}>{label}</span>
      {direction && (
        <>
          {direction === 'asc' ? (
            <ArrowUpIcon
              className={selected ? styles['z-arrow-primary'] : styles['z-arrow-secondary']}
            />
          ) : (
            <ArrowDownIcon
              className={selected ? styles['z-arrow-primary'] : styles['z-arrow-secondary']}
            />
          )}
        </>
      )}
    </button>
  );
};

export default Tab;
export type { Props as TabProps };
